import { ThemeContext } from "@emotion/react";
import { useContext } from "react";

const useRefreshTheme = () => {
  return useContext(ThemeContext);
};

export default useRefreshTheme;
